<div class="d-flex">
  <s1-input-autocomplete class="pr-3" [control]="control" [label]="'shared.fields.entita'" [config]="api.autocompleteTypes.entita" (elementSelected)="itemSelected($event)"></s1-input-autocomplete>
  <input class="form-control" type="text" [(ngModel)]="description" [readonly]="true"/>
</div>